import { CLIENT_LOGOS } from "../data/content";

export const LogoMarquee = () => {
  const items = [...CLIENT_LOGOS, ...CLIENT_LOGOS];
  return (
    <section data-testid="logo-marquee" className="border-y border-black/10 bg-white py-10 lg:py-14">
      <p data-testid="logo-marquee-heading" className="font-gothic mx-auto max-w-7xl px-5 text-center uppercase tracking-[0.18em] text-xs text-black/60 sm:px-8 sm:text-sm">
        Creating fun for some of the top companies, country clubs, and communities.
      </p>
      <div className="marquee mt-8" aria-label="Client logos">
        <div className="marquee-track">
          {items.map((l, i) => (
            <div key={`${l.file}-${i}`} className="marquee-item" aria-hidden={i >= CLIENT_LOGOS.length ? "true" : undefined}>
              <img src={`/images/clients/${l.file}.png`} alt={i < CLIENT_LOGOS.length ? `${l.name} logo` : ""} loading="lazy" decoding="async" width="200" height="48" className="h-10 w-auto max-w-[160px] object-contain sm:h-12 sm:max-w-[200px]" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
